import * as CookieConsent from 'vanilla-cookieconsent'

const COOKIE_NAME = 'evidentist_cookies'

declare let gtag: any

const doesCookieExists = () => document.cookie?.includes(COOKIE_NAME)

export const defaultConsent = gtmService => {
  // todo asana question
  const dl = gtmService.getDataLayer()
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'denied',
    wait_for_update: 10000,
  })
  gtag('set', 'ads_data_redaction', true)
  gtag({ event: 'defaultConsentsSet' })
}

export const cookieConsent = async (gtmService, translateService) => {
  // if (!doesCookieExists()) {
  // defaultConsent(gtmService) // this is already in page header
  // }
  const dl = gtmService.getDataLayer()
  const pushTag = tag => gtmService.pushTag(tag)
  const updateGtagConsent = () => {
    gtag('consent', 'update', {
      ad_storage: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
      ad_user_data: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
      ad_personalization: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
      analytics_storage: CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
      functionality_storage: CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
      personalization_storage: CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
    })
    dl.push({ event: 'consent_update' })
  }
  // CookieConsent.hide()
  // await wait(1500)
  // CookieConsent.eraseCookies(COOKIE_NAME) // todo test
  CookieConsent.run({
    cookie: {
      name: COOKIE_NAME,
    },
    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
      consentModal: {
        layout: 'box',
        position: 'bottom right',
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: 'box',
        equalWeightButtons: true,
        flipButtons: false,
      },
    },

    onConsent: ({ cookie }) => {
      updateGtagConsent()
      // CookieConsent.setCookieData({ value: cookie, mode: 'overwrite' })
      // console.log('onset c', CookieConsent.getCookie())
    },

    onChange: ({ changedCategories, changedServices }) => {
      // console.log({changedCategories, changedServices})
      updateGtagConsent()
    },

    categories: {
      necessary: {
        enabled: true, // this category is enabled by default
        readOnly: true, // this category cannot be disabled
      },
      analytics: {},
    },

    language: {
      // default: document.documentElement.getAttribute('lang'),
      default: 'en', // translate by weblate
      translations: {
        en: {
          consentModal: {
            title: translateService.instant('consentModal.title'),
            description: translateService.instant('consentModal.description'),
            acceptAllBtn: translateService.instant('consentModal.acceptAllBtn'),
            acceptNecessaryBtn: translateService.instant('consentModal.acceptNecessaryBtn'),
            showPreferencesBtn: translateService.instant('consentModal.showPreferencesBtn'),
            // closeIconLabel: 'Reject all and close modal',
          },
          preferencesModal: {
            title: translateService.instant('preferencesModal.title'),
            acceptAllBtn: translateService.instant('preferencesModal.acceptAllBtn'),
            acceptNecessaryBtn: translateService.instant('preferencesModal.acceptNecessaryBtn'),
            savePreferencesBtn: translateService.instant('preferencesModal.savePreferencesBtn'),
            closeIconLabel: translateService.instant('preferencesModal.closeIconLabel'),
            serviceCounterLabel: translateService.instant('preferencesModal.serviceCounterLabel'),
            sections: [
              {
                title: translateService.instant('preferencesModal.sections.0.title'),
                description: translateService.instant('preferencesModal.sections.0.description'),
              },
              {
                title: translateService.instant('preferencesModal.sections.1.title'),
                description: translateService.instant('preferencesModal.sections.1.description'),
                linkedCategory: 'necessary',
              },
              {
                title: translateService.instant('preferencesModal.sections.2.title'),
                description: translateService.instant('preferencesModal.sections.2.description'),
                linkedCategory: 'analytics',
                cookieTable: {
                  caption: translateService.instant('preferencesModal.sections.2.cookieTable.caption'),
                  headers: {
                    name: translateService.instant('preferencesModal.sections.2.cookieTable.headers.name'),
                    domain: translateService.instant('preferencesModal.sections.2.cookieTable.headers.domain'),
                    desc: translateService.instant('preferencesModal.sections.2.cookieTable.headers.desc'),
                  },
                  body: [
                    {
                      name: '^_ga',
                      domain: 'google.com',
                      desc: translateService.instant('preferencesModal.sections.2.cookieTable.body.0.desc'),
                    },
                    {
                      name: '_gid',
                      domain: 'google.com',
                      desc: translateService.instant('preferencesModal.sections.2.cookieTable.body.1.desc'),
                    },
                  ],
                },
              },
              // {
              //   title: translateService.instant('preferencesModal.sections.3.title'),
              //   description: translateService.instant('preferencesModal.sections.3.description'),
              //   linkedCategory: 'ads',
              // },
              {
                title: translateService.instant('preferencesModal.sections.4.title'),
                description: translateService.instant('preferencesModal.sections.4.description'),
              },
            ],
          },
        },
      },
    },
  })
}

export const showCookieConsentDialog = () => {
  CookieConsent.show(true)
}
